export default __webpack_public_path__ + "static/media/mergeAccountsSecondCardIcon.a992b05d.svg";